module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/add-4ca5bf711d826a6ac9cdc8520fbd7fd4.svg";